import type { ISnackbarItem } from '@manager/modules/snackbar/snackbar-types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSnackbarStore = defineStore('snackbar', () => {
  const queue = ref<ISnackbarItem[]>([]);

  return { queue };
});
